import { render, staticRenderFns } from "./PlanTratamiento.vue?vue&type=template&id=1d7a6912"
import script from "./PlanTratamiento.vue?vue&type=script&lang=js"
export * from "./PlanTratamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports